/* PULMUR - coffee match quiz.
   Questions, options and every possible result are rendered by Liquid and live
   in the DOM from the first byte. This file only decides what is visible and
   scores tag overlap, so crawlers and no-JS visitors still read the whole page.
   ponytail: scoring is a plain tag-overlap count. Add weights only if the
   recommendations actually come out wrong. */
(function () {
  var RANKS = ["Your match", "Also a great fit", "Worth a try"];
  var SHOW = 3;

  function hide(el, yes) {
    el.setAttribute("data-pbt-hide", yes ? "true" : "false");
  }

  function tagsOf(el) {
    return (el.getAttribute("data-tags") || "")
      .toLowerCase()
      .split(",")
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
  }

  function init(root) {
    var form = root.querySelector("[data-quiz-form]");
    var questions = Array.prototype.slice.call(root.querySelectorAll("[data-quiz-q]"));
    var results = Array.prototype.slice.call(root.querySelectorAll("[data-quiz-result]"));
    var resultsWrap = root.querySelector("[data-quiz-results]");
    if (!form || !questions.length || !resultsWrap) return;

    var fill = root.querySelector("[data-quiz-fill]");
    var counter = root.querySelector("[data-quiz-i]");
    var backBtn = root.querySelector("[data-quiz-back]");
    var loader = root.querySelector("[data-quiz-loading]");
    var promoBtn = root.querySelector("[data-promo-copy]");
    var delay = parseInt(root.getAttribute("data-delay"), 10);
    if (isNaN(delay)) delay = 1400;
    var restartBtn = root.querySelector("[data-quiz-restart]");
    var startWrap = root.querySelector("[data-quiz-start]");
    var goBtn = root.querySelector("[data-quiz-go]");
    var progress = root.querySelector("[data-quiz-progress]");
    // The page heading lives outside the quiz root, so it is toggled with the
    // hidden attribute rather than the .pbt-js data-attribute rule.
    var inner = root.closest(".pbt__inner");
    var head = inner ? inner.querySelector("[data-quiz-head]") : null;
    var resultsList = resultsWrap.querySelector("[data-quiz-list]") || resultsWrap;
    var at = 0;

    if (root.getAttribute("data-pbt-ready") === "1") return;
    root.setAttribute("data-pbt-ready", "1");
    root.classList.add("pbt-js");

    function show(i) {
      at = Math.max(0, Math.min(questions.length - 1, i));
      questions.forEach(function (q, n) { hide(q, n !== at); });
      if (counter) counter.textContent = at + 1;
      if (fill) fill.style.width = ((at) / questions.length) * 100 + "%";
      if (backBtn) backBtn.hidden = at === 0;
    }

    function score() {
      var picked = [];
      questions.forEach(function (q) {
        var input = q.querySelector("input:checked");
        if (input) picked = picked.concat(tagsOf(input));
      });

      var ranked = results
        .map(function (el, order) {
          var hits = tagsOf(el).filter(function (t) { return picked.indexOf(t) !== -1; });
          return { el: el, order: order, score: hits.length, hits: hits };
        })
        .sort(function (a, b) { return b.score - a.score || a.order - b.order; });

      ranked.forEach(function (r, i) {
        var top = i < SHOW;
        hide(r.el, !top);
        r.el.classList.toggle("pbt-res--top", i === 0);
        r.el.classList.toggle("pbt-res--alt", i > 0);
        var rank = r.el.querySelector("[data-res-rank]");
        if (rank && top) rank.textContent = RANKS[i] || "Also good";
        if (top) resultsList.appendChild(r.el);
      });

      hide(form, true);
      if (fill) fill.style.width = "100%";

      // A beat of "we are working on it" makes the result feel earned rather
      // than pre-baked. Length is a theme setting, not a magic number.
      var reveal = function () {
        if (loader) hide(loader, true);
        hide(resultsWrap, false);
        var head = resultsWrap.querySelector("h2, h3");
        if (head) {
          head.setAttribute("tabindex", "-1");
          head.focus({ preventScroll: true });
          head.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

      if (loader && delay > 0) {
        hide(loader, false);
        loader.scrollIntoView({ behavior: "smooth", block: "center" });
        setTimeout(reveal, delay);
      } else {
        reveal();
      }
    }

    function go() {
      if (startWrap) hide(startWrap, true);
      if (progress) hide(progress, false);
      if (head) head.hidden = true;
      show(0);
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function advance() {
      if (at < questions.length - 1) show(at + 1);
      else score();
    }

    form.addEventListener("change", function (e) {
      if (e.target.matches("input[type=radio]")) setTimeout(advance, 220);
    });

    if (goBtn) {
      goBtn.addEventListener("click", go);
    }

    if (backBtn) {
      backBtn.addEventListener("click", function () { show(at - 1); });
    }

    if (restartBtn) {
      restartBtn.addEventListener("click", function () {
        form.reset();
        results.forEach(function (el) {
          hide(el, false);
          el.classList.remove("pbt-res--top", "pbt-res--alt");
        });
        hide(resultsWrap, true);
        if (loader) hide(loader, true);
        hide(form, false);
        at = 0;
        if (fill) fill.style.width = "0%";
        if (counter) counter.textContent = 1;
        questions.forEach(function (q) { hide(q, true); });
        if (progress) hide(progress, true);
        if (startWrap) hide(startWrap, false);
        if (head) head.hidden = false;
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    if (promoBtn) {
      promoBtn.addEventListener("click", function () {
        var codeEl = root.querySelector("[data-promo-code]");
        var code = codeEl ? codeEl.textContent.trim() : "";
        var done = function () {
          promoBtn.textContent = "Copied";
          setTimeout(function () { promoBtn.textContent = "Copy code"; }, 1600);
        };
        if (code && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    }

    hide(resultsWrap, true);
    if (loader) hide(loader, true);
    results.forEach(function (el) { hide(el, false); });
    questions.forEach(function (q) { hide(q, true); });
    if (progress) hide(progress, true);
    if (startWrap) hide(startWrap, false);

    // No start button configured? Behave as before and open on question 1.
    if (!goBtn) go();
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-pbt-quiz]").forEach(function (el) {
      el.classList.add("pbt-js");
      init(el);
    });
  }

  // Exposed so the PDP modal can start a quiz it injected after page load.
  window.PulmurQuiz = { init: boot };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
